import { castArray } from 'lodash'

export function getTagIds(tags) {
  return castArray(tags || [])
}
